// sectionEventQueue.js
// A small module-level queue that SectionTracker components push into, and
// useSectionTrackingFlush periodically drains and sends to the backend.
// Kept separate from the component so multiple sections can share one flush timer
// instead of each section running its own interval.

import { clientApi } from "./clientApi";

const openSections = new Map(); // sectionName -> Date entered
let completedQueue = [];

export function markSectionEntered(sectionName) {
  if (!openSections.has(sectionName)) {
    openSections.set(sectionName, new Date());
  }
}

export function markSectionExited(sectionName) {
  const enteredAt = openSections.get(sectionName);
  if (!enteredAt) return; // exit without a matching enter - ignore

  completedQueue.push({
    sectionName,
    enteredAt: enteredAt.toISOString(),
    exitedAt: new Date().toISOString(),
  });
  openSections.delete(sectionName);
}

/** Call on tab-hide/unmount/logout so we don't lose dwell time for sections still in view. */
export function closeAllOpenSections() {
  const names = Array.from(openSections.keys());
  names.forEach((name) => markSectionExited(name));
}

export async function flushSectionEvents() {
  if (completedQueue.length === 0) return;

  const batch = completedQueue;
  completedQueue = []; // clear immediately so new events during the request aren't dropped or duplicated

  try {
    await clientApi.sendSectionEvents(batch);
  } catch {
    // Analytics data, not critical - if the flush fails we simply lose that batch
    // rather than retrying indefinitely and risking a growing backlog.
  }
}
